var _rect, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGooglePlayLightSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 41.6,
    height: 41.6,
    rx: 8,
    transform: "matrix(1.25 0 0 -1.25 0 52)",
    fill: "#DCE3E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.244 9.79751C10.8529 10.1973 10.6265 10.8196 10.6265 11.6256V40.3751C10.6265 41.1811 10.8529 41.8035 11.244 42.2033L11.3405 42.291L27.8412 26.1873V25.807L11.3405 9.70327L11.244 9.79751Z",
    fill: "url(#paint0_linear_3336_15291)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.335 31.5586L27.8409 26.188V25.8077L33.3416 20.4371L33.4648 20.507L39.9792 24.1258C41.8383 25.1528 41.8383 26.8428 39.9792 27.8763L33.4648 31.4887L33.335 31.5586V31.5586Z",
    fill: "url(#paint1_linear_3336_15291)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4648 31.4883L27.8409 25.9974L11.2437 42.2035C11.8612 42.8373 12.8681 42.9137 14.0132 42.2799L33.4648 31.4883",
    fill: "url(#paint2_linear_3336_15291)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4648 20.5072L14.0132 9.71555C12.8681 9.0883 11.8612 9.16467 11.2437 9.79842L27.8409 25.998L33.4648 20.5072Z",
    fill: "url(#paint3_linear_3336_15291)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3336_15291",
    x1: 26.3761,
    y1: 40.6745,
    x2: 4.56524,
    y2: 18.3352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3336_15291",
    x1: 42.4,
    y1: 25.996,
    x2: 10.1819,
    y2: 25.996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3336_15291",
    x1: 30.4067,
    y1: 23.0125,
    x2: 0.829359,
    y2: -7.28153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3336_15291",
    x1: 7.06586,
    y1: 51.769,
    x2: 20.2735,
    y2: 38.2415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayLightSquare);
export default __webpack_public_path__ + "static/media/google_play_light_square.4cf26853cb5b254c125a72c48d5e4875.svg";
export { ForwardRef as ReactComponent };